/**
 * @param {Number} [ts] TS vai gads
 * @param {Number} [m] 1 - 12
 * @param {Number} [d]
 * @constructor
 */
D.Date = function( ts, m, d ){
	if( isset( m, d ) ){
		this._date = new Date( ts, m - 1, d );
		return;
	}
	this._date = new Date();
	if(ts){
		this.setTime(ts);
	} else if( D.TIME ){
		this.setTime( D.TIME );
	}
};

D.Date.prototype.valueOf = function(){
	return this.getTime();
};

D.Date.prototype.getTime = function(){
	if( !this._date.getTime() ){
		return 0;
	}
	return Math.round( this._date.getTime() / 1000 );
};

D.Date.prototype.setTime = function(v){
	this._date.setTime( v * 1000 );
	return this;
};

D.Date.prototype.getYear = function(){
	return this._date.getFullYear();
};

D.Date.prototype.setYear = function(v){
	this._date.setFullYear(v);
	return this;
};

D.Date.prototype.getMonth = function(){
	return this._date.getMonth() + 1;
};

D.Date.prototype.setMonth = function(v){
	this._date.setMonth( v - 1 );
	// fix, ja iepriekshejaa meenesii nav bijis taads datums
	if( this.getMonth() != v ){
		this._date.setDate(1);
		this._date.setMonth( v - 1 );
	}
	return this;
};

D.Date.prototype.getDate = function(){
	return this._date.getDate();
};

D.Date.prototype.setDate = function(v){
	this._date.setDate(v);
	return this;
};

D.Date.prototype.getHours = function(){
	return this._date.getHours()
};

D.Date.prototype.setHours = function(v){
	this._date.setHours(v);
	return this;
};

D.Date.prototype.getMinutes = function(){
	return this._date.getMinutes()
};

D.Date.prototype.setMinutes = function(v){
	this._date.setMinutes(v);
	return this;
};

D.Date.prototype.getSeconds = function(){
	return this._date.getSeconds()
};

D.Date.prototype.setSeconds = function(v){
	this._date.setSeconds(v);
	return this;
};

D.Date.prototype._zeroFill = function(v){
	if( v < 10 ){
		return '0' + String(v);
	}
	return String(v);
};

D.Date.prototype.getSuffix = function(){
	let d = this.getDate();
	if (d > 3 && d < 21) return 'th';
	switch (d % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
};

D.Date.prototype.format = function(format){
	return format
		.replace( 'Y', this.getYear() )
		.replace( 'y', String( this.getYear() ).substr(-2) )
		.replace( 'm', this._zeroFill( this.getMonth() ) )
		.replace( 'n', this.getMonth() )
		.replace( 'd', this._zeroFill( this.getDate() ) )
		.replace( 'j', this.getDate() )
		.replace( 'H', this._zeroFill( this.getHours() ) )
		.replace( 'G', this.getHours() )
		.replace( 'h', this._zeroFill( this.getHours() % 12 || 12 ) )
		.replace( 'g', this.getHours() % 12 || 12 )
		.replace( 'i', this._zeroFill( this.getMinutes() ) )
		.replace( 's', this._zeroFill( this.getSeconds() ) )
		.replace( 'S', this.getSuffix() )
		// textual
		.replace('%k', this.getDayNameKad())
		.replace('%l', this.getDayNameLong())
		.replace('%D', this.getDayName())
		.replace('%F', this.getMonthName()) // Pilns mēneša nosaukums
		.replace('%J', this.getMonthNameDat()) // Pilns mēneša nosaukums datīvs
		.replace('%M', this.getMonthNameShort()) // Īsais mēneša nosaukums
		.replace('%L', this.getMonthNameLok()) // Pilns mēneša nosaukums lokatīvs
		.replace('%A', this.getMonthNameAk()) // Pilns mēneša nosaukums akuzatīvs
		.replace('%B', this.getMonthNameGen()); // Pilns mēneša nosaukums ģenitīvs
};

D.Date.prototype.format2 = function ( format ) {
	return format
		// textual
		.replace('%dZ', () => this.getDayNameKad())
		.replace('%dN', () => this.getDayNameLong())
		.replace('%dSN', () => this.getDayName())
		.replace('%mN', () => this.getMonthName()) // Pilns mēneša nosaukums
		.replace('%mD', () => this.getMonthNameDat()) // Pilns mēneša nosaukums datīvs
		.replace('%mS', () => this.getMonthNameShort()) // Īsais mēneša nosaukums
		.replace('%mL', () => this.getMonthNameLok()) // Pilns mēneša nosaukums lokatīvs
		.replace('%mA', () => this.getMonthNameAk()) // Pilns mēneša nosaukums akuzatīvs
		.replace('%mG', () => this.getMonthNameGen()) // Pilns mēneša nosaukums ģenitīvs
		.replace('%Y', () => this.getYear())
		.replace('%y', () => String(this.getYear()).substr(-2))
		.replace('%m', () => this._zeroFill(this.getMonth()))
		.replace('%n', () => this.getMonth())
		.replace('%d', () => this._zeroFill(this.getDate()))
		.replace('%j', () => this.getDate())
		.replace('%H', () => this._zeroFill(this.getHours()))
		.replace('%G', () => this.getHours())
		.replace('%h', () => this._zeroFill(this.getHours() % 12 || 12))
		.replace('%g', () => this.getHours() % 12 || 12)
		.replace('%i', () => this._zeroFill(this.getMinutes()))
		.replace('%s', () => this._zeroFill(this.getSeconds()))
		.replace('%S', () => this.getSuffix());
};

D.Date.prototype.getDayNear = function(){
	var today = new D.Date(), ymd = this.format('Ymd');
	if( this.format('Ymd') === today.format('Ymd') ) {
		return ucfirst(D.Lang.get('date.today'));
	} else if( ymd === today.setDate(today.getDate()+2).format('Ymd') ) {
		return ucfirst(D.Lang.get('date.dayaftertomorrow'));
	} else if( ymd === today.setDate(today.getDate()-1).format('Ymd') ) {
		return ucfirst(D.Lang.get('day.tomorrow'));
	} else if( ymd === today.setDate(today.getDate()-2).format('Ymd') ) {
		return ucfirst(D.Lang.get('day.yesterday'));
	}
	return false;
};

D.Date.prototype._readDigits = function( text, max ){
	var num = '';
	var i;
	for( i = 0; i < text.length; ++ i ){
		var char = text[i];
		var code = char.charCodeAt(0);
		if( code < 48 || code > 57 ){
			if(num){
				break;
			} else { // kamēr atrod ciparu
//				D.log( 'skip', char );
				continue;
			}
		}
		num += char;
		if( num.length == max ){
			break;
		}
	}
	text = text.substr( i + 1 );
//	D.log( {
//		text:text,
//		num:Number(num)
//	} );
	return {
		text:text,
		num:Number(num),
		numText:num
	};
};

D.Date.prototype.resetTime = function(){
	this.setHours(0).setMinutes(0).setSeconds(0);
	return this;
};

D.Date.prototype.fromFormat = function( format, v ){
	v = String(v);
	this.resetTime();
	var y, m, d;
	for( var i = 0; i < format.length; ++ i ){
		switch( format[i] ){
			case 'Y':
				var r = this._readDigits( v, 4 );
				v = r.text;
				//this.setYear( r.num );
				y = r.num;
				break;
			case 'y':
				var r = this._readDigits( v, 2 );
				v = r.text;
				if( r.num > 50 ){
					//this.setYear( 1900 + r.num );
					y = 1900 + r.num;
				} else {
					//this.setYear( 2000 + r.num );
					y = 2000 + r.num;
				}
				break;
			case 'm':
				var r = this._readDigits( v, 2 );
				v = r.text;
				//this.setMonth( r.num || 1 );
				m = r.num || 1;
				break;
			case 'd':
				var r = this._readDigits( v, 2 );
				v = r.text;
				//this.setDate( r.num || 1 );
				d = r.num || 1;
				break;
			case 'H':
				var r = this._readDigits( v, 2 );
				v = r.text;
				this.setHours( r.num || 0 );
				break;
			case 'i':
				var r = this._readDigits( v, 2 );
				v = r.text;
				this.setMinutes( r.num || 0 );
				break;
			case 's':
				var r = this._readDigits( v, 2 );
				v = r.text;
				this.setSeconds( r.num || 0 );
				break;
		}
	}
	// svarīga secība
	if(y){
		this.setYear(y);
	}
	if(m){
		this.setMonth(m);
	}
	if(d){
		this.setDate(d);
	}
	return this;
};

D.Date.prototype.setYMD = function( y, m, d ){
	this._date = new Date( y, m - 1, d );
	return this;
};

D.Date.prototype.toSql = function(){
	return this.format('Y-m-d H:i:s');
};

D.Date.prototype.toSqlDate = function(){
	return this.format('Y-m-d');
};

D.Date.prototype.toSqlTime = function(){
	return this.format('H:i:s');
};

D.Date.prototype.fromSqlDate = function(v){
	var a = v.split('-');
	this.setYMD( a[0], a[1], a[2] );
	return this;
};

D.Date.prototype.fromSqlTime = function(v){
	var a = v.split(':');
	this.setHours( a[0] || 0 ).setMinutes( a[1] || 0 ).setSeconds( a[2] || 0 );
	return this;
};

D.Date.prototype.fromSql = function(v){
	var a = v.split(' ');
	this.fromSqlDate( a[0] ).fromSqlTime( a[1] || '' );
	return this;
};

D.Date.prototype.getDayName = function(){
	return D.Lang.get( 'date.day.short.i' + String( this.dayOfWeek() ) );
};
D.Date.prototype.getMonthName = function(){
	return D.Lang.get( 'date.month.i' + String( this._date.getMonth() + 1 ) );
};
D.Date.prototype.getMonthNameShort = function(){
	return D.Lang.get('date.months.short.i' + String(this._date.getMonth() + 1)).substr(0, 3);
};
D.Date.prototype.before = function(){
	return D.ddate2( this.getTime() );
};
D.Date.prototype.getDayNameLong = function(){
	return D.Lang.get('date.day.i' + String(this.dayOfWeek()));
};
D.Date.prototype.getDayNameKad = function(){
	return D.Lang.get('date.day.when.i' + String(this.dayOfWeek()));
};
D.Date.prototype.getMonthNameLok = function(){
	return D.Lang.get('date.month.lok.i' + String(this._date.getMonth() + 1));
};
D.Date.prototype.getMonthNameDat = function(){
	return D.Lang.get('date.month.dat.i' + String(this._date.getMonth() + 1));
};
D.Date.prototype.getMonthNameGen = function(){
	return D.Lang.get('date.month.gen.i' + String(this._date.getMonth() + 1));
};
D.Date.prototype.getMonthNameAk = function(){
	return D.Lang.get('date.month.ak.i' + String(this._date.getMonth() + 1));
};


D.Date.prototype.toString = function(par){
	return D.ddate( this.getTime(), par );
};

/**
 * 1 - P, 2 - O, ... 7 - Sv
 */
D.Date.prototype.dayOfWeek = function(){
	var d = this._date.getDay();
	if(!d){
		return 7;
	}
	return d;
};

D.Date.formatDateRange = function(tsFrom, tsTo, format1, format2, sep){
	const d1 = new this(tsFrom), d2 = new this(tsTo);
	if( tsFrom === tsTo ){
		return d1.format(format1);
	} else if ( d1.format('Ymd') === d2.format('Ymd') ) {
		return d1.format(format1) + sep + d2.format(format2);
	} else {
		return d1.format(format1) + sep + d2.format(format1);
	}
};

D.Date.format2DateRange = function(tsFrom, tsTo, format1, format2, sep){
	const d1 = new this(tsFrom), d2 = new this(tsTo);
	if( tsFrom === tsTo ){
		return d1.format2(format1);
	} else if ( d1.format2('Ymd') === d2.format2('Ymd') ) {
		return d1.format2(format1) + sep + d2.format2(format2);
	} else {
		return d1.format2(format1) + sep + d2.format2(format1);
	}
};